import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types'

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit,
  },
});

class TagSelection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      amountBanners: 4,
      tagGroups: props.data
    }
    this.addAvailability();
  }

  componentWillReceiveProps = props => {
    this.setState({ tagGroups: props.data })
  }

  handleClickTag = (e, tagGroupId, tagId) => {
    let tagGroup = this.state.tagGroups.find((tagGroup) => tagGroup.id === tagGroupId);

    let tag = tagGroup.tags.find((tag) => tag.id === tagId);
    if (tag.state === 'available') {
      tag.state = 'selected'
      this.setState(this.state)
    } else if (tag.state === 'selected' && this.props.allowUnselected) {
      tag.state = 'unselected'
      this.setState(this.state)
    } else if (tag.state === 'unselected' && this.props.allowUnselected) {
      tag.state = 'available'
      this.setState(this.state)
    } else if (tag.state === 'selected' && !this.props.allowUnselected) {
      tag.state = 'available'
      this.setState(this.state)
    }
  }

  handleChange = () => {
    let selected = [], unselected = []
    this.state.tagGroups.forEach(tagGroup => {
      tagGroup.tags.forEach(tag => {
        if (tag.state === "selected") {
          selected.push(tag.id)
        }
        if (tag.state === 'unselected') {
          unselected.push(tag.id)
        }
      })
    });
    if (this.props.onSelectedTagsChanged) {
      this.props.onSelectedTagsChanged(selected, unselected);
    }
  }

  addAvailability = () => {
    this.state.tagGroups.forEach(tagGroup => {
      tagGroup.tags.forEach(tag => {
        if (!tag.state) {
          tag.state = "available"
        }
      })
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <div style={{ float: "left", position: "relative", width: "100%" }}>
        {this.state.tagGroups.map((tagGroup, i) => {
          return (
            <div key={i}>
              <div style={{ width: "100%" }}>
                <h4 style={this.props.bloomCloudsView ? {fontSize: '14px', textTransform: 'uppercase', marginBottom: '0px'}: {}}>{tagGroup.name}</h4>
              </div>
              <div style={this.props.bloomCloudsView ? { width: '100%', marginBottom: '30px' } : { width: "100%" }}>

                {
                  tagGroup.tags.map((tag, j) => {
                  return (
                    <Chip key={j}
                      style={
                        this.props.bloomCloudsView
                        ? 
                          {
                            minWidth: '120px',
                            marginLeft: '0px',
                            marginBottom: "5px",
                            fontWeight: "400",
                            backgroundColor: tag.state === "selected" ? '#141414' : tag.state === 'available' ? 'white' :'#e0e0e0',
                            color: tag.state === "selected" ? 'white' : tag.state === 'available' ? '#141414' : 'grey',
                            cursor: tag.state === "disable" ? 'auto' : 'pointer',
                            border: '1px solid #e4e4e4'
                          } 
                        :
                          {
                            marginLeft: "10px",
                            marginBottom: "5px",
                            fontWeight: "400",
                            backgroundColor: tag.state === "selected" ? '#224b77' : tag.state === 'unselected' ? '#e68484' :'#e0e0e0',
                            color: (tag.state === "selected" || tag.state === 'unselected') ? 'white' : tag.state === "disable" ? 'grey' : 'black',
                            cursor: tag.state === "disable" ? 'auto' : 'pointer'
                          }
                      }
                      label={tag.name}
                      className={classes.chip}
                      onClick={(e) => {
                        if (this.props.disabled) return
                        if(this.props.homeElementTagSelection) {
                          this.props.onSelectedTagsChanged(tag.id)
                        }else {
                          this.handleClickTag(e, tagGroup.id, tag.id);
                          this.handleChange()
                        }
                        }
                      }
                    />
                  )
                })}
              </div>
            </div>
          )
        })}

      </div>
    )
  }

}

TagSelection.propTypes = {

  data: PropTypes.array.isRequired,
}

export default withStyles(styles)(TagSelection);
